import { Injectable } from '@angular/core';
import moment from 'moment';
import { Observable, timer } from 'rxjs';
import { map, takeWhile } from 'rxjs/operators';

const timeOutHours = 4; // 4 hours is the timeout for pace online and pace fi

@Injectable({
    providedIn: 'root',
})
export class AuthenticationTimeoutService {
    public countdown$: Observable<string>;
    private endTime: moment.Moment;

    public initializeCounter(): void {
        this.endTime = moment().add(timeOutHours, 'hours');

        this.countdown$ = timer(0, 1000).pipe(
            map(() => {
                const currentTime = moment();
                const duration = moment.duration(this.endTime.diff(currentTime));
                const formattedDuration = duration.format('hh:mm:ss');
                return formattedDuration;
            }),
            takeWhile(() => this.endTime.isAfter(moment())),
        );
    }
}
